module.exports = __webpack_public_path__ + "img/PL08636.74b18330.png";